module.exports = __webpack_public_path__ + "static/media/20200803.dd9ab7b1.jpg";